import { Box } from "@mui/material";
import Header from "../Header";
import Footer from "../Footer";
import { ScrollToTopButton } from "../ScrollToTopButton";
import MainVisual from "./MainVisual";
import BusinessAreaSection from "./BusinessAreaSection";
import Portfolio from "./Portfolio";
import Contact from "./Contact";

export const Home = () => {
  return (
    <Box sx={{ overflowX: "hidden", position: "relative" }}>
      <Header />
      <MainVisual />
      <BusinessAreaSection />
      <Portfolio />
      <Contact />
      <Footer />
      <ScrollToTopButton />
    </Box>
  );
};
